// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"2313":"c260d704","6837":"ffb83ad3","9086":"c7d2b47f","9474":"017446fc"}[chunkId] + ".css";
};